const footer = {
  brand: {
    description:
      "Premium-Zahnpflege in Sofia, Bulgarien. Wir kombinieren fortschrittliche Technologie mit personalisierten Behandlungen, um Ihnen das perfekte Lächeln zu schenken, das Sie verdienen.",
  },
  quickLinks: {
    title: "Schnelllinks",
    home: "Home",
    about: "Über uns",
    services: "Leistungen",
    testimonials: "Zufriedene Kunden",
    gallery: "Galerie",
    contact: "Kontakt",
  },
  services: {
    title: "Unsere Leistungen",
    list: {
      implantology: "Implantologie",
      endodontics: "Endodontie",
      "oral-surgery": "Oralchirurgie",
      periodontology: "Parodontologie",
      orthodontics: "Kieferorthopädie",
      prosthetics: "Prothetik",
    },
  },
  questions: {
    title: "Haben Sie Fragen?",
    description:
      "Wir sind hier, um zu helfen! Kontaktieren Sie uns bei Fragen zu unseren zahnärztlichen Leistungen oder um einen Termin zu vereinbaren.",
    buttonLabel: "Kontaktieren Sie uns",
  },
  bottom: {
    copyright: "© {{year}} Elite Dental Solutions. Alle Rechte vorbehalten.",
  },
  legal: {
    privacyPolicy: "Datenschutzerklärung",
    termsOfService: "Nutzungsbedingungen",
  },
};

export default footer;
